export const I18N_KEYS = {
  mobile: "mobile",

  welcome: {
    text001: "welcome.text001",
    text002: "welcome.text002",
    text003: "welcome.text003",
  },

  selectAccountType: {
    text001: "select-account-type.text001",
    text002: "select-account-type.text002",
    text003: "select-account-type.text003",
    text004: "select-account-type.text004",
  },

  signUpBusiness: {
    text001: "sign-up-business.text001",
    text002: "sign-up-business.text002",
    text003: "sign-up-business.text003",
    text004: "sign-up-business.text004",
    text005: "sign-up-business.text005",
    text006: "sign-up-business.text006",
    text007: "sign-up-business.text007",
    text008: "sign-up-business.text008",
    text009: "sign-up-business.text009",
    text010: "sign-up-business.text010",
    text011: "sign-up-business.text011",
    text012: "sign-up-business.text012",
    text013: "sign-up-business.text013",
    text014: "sign-up-business.text014",
    text015: "sign-up-business.text015",
    text016: "sign-up-business.text016",
    text017: "sign-up-business.text017",
    text018: "sign-up-business.text018",
    text019: "sign-up-business.text019",
    text020: "sign-up-business.text020",
    text021: "sign-up-business.text021",
    text022: "sign-up-business.text022",
    text023: "sign-up-business.text023",
    text024: "sign-up-business.text024",
    text025: "sign-up-business.text025",
  },

  signUpEmployee: {
    text001: "sign-up-employee.text001",
    text002: "sign-up-employee.text002",
    text003: "sign-up-employee.text003",
    text004: "sign-up-employee.text004",
    text005: "sign-up-employee.text005",
    text006: "sign-up-employee.text006",
    text007: "sign-up-employee.text007",
    text008: "sign-up-employee.text008",
    text009: "sign-up-employee.text009",
    text010: "sign-up-employee.text010",
    text011: "sign-up-employee.text011",
    text012: "sign-up-employee.text012",
    text013: "sign-up-employee.text013",
    text014: "sign-up-employee.text014",
    text015: "sign-up-employee.text015",
    text016: "sign-up-employee.text016",
    text017: "sign-up-employee.text017",
    text018: "sign-up-employee.text018",
    text019: "sign-up-employee.text019",
  },

  login: {
    text001: "login.text001",
    text002: "login.text002",
    text003: "login.text003",
    text004: "login.text004",
    text005: "login.text005",
    text006: "login.text006",
    text007: "login.text007",
    text008: "login.text008",
    text009: "login.text009",
    text010: "login.text010",
    text011: "login.text011",
    text012: "login.text012",
  },

  resetPassword: {
    text001: "reset-password.text001",
    text002: "reset-password.text002",
    text003: "reset-password.text003",
    text004: "reset-password.text004",
    text005: "reset-password.text005",
    text006: "reset-password.text006",
    text007: "reset-password.text007",
  },

  verifyPassword: {
    text001: "verify-password.text001",
    text002: "verify-password.text002",
    text003: "verify-password.text003",
    text004: "verify-password.text004",
    text005: "verify-password.text005",
  },

  homeError: {
    text001: "home-error.text001",
    text002: "home-error.text002",
    text003: "home-error.text003",
    noGolf: {
      text001: "home-error.no-golf.text001",
      text002: "home-error.no-golf.text002",
      text003: "home-error.no-golf.text003",
      text004: "home-error.no-golf.text004",
    },
    requireVerification: {
      text001: "home-error.require-verification.text001",
      text002: "home-error.require-verification.text002",
      text003: "home-error.require-verification.text003",
      text004: "home-error.require-verification.text004",
    },
    pendingVerification: {
      text001: "home-error.pending-verfication.text001",
      text002: "home-error.pending-verfication.text002",
      text003: "home-error.pending-verfication.text003",
      text004: "home-error.pending-verfication.text004",
    },
  },

  home: {
    text001: "home.text001",
    text002: "home.text002",
    text003: "home.text003",
  },

  signup: {
    verify: {
      text001: "signup.verify.text001",
      text002: "signup.verify.text002",
      text003: "signup.verify.text003",
      verified: {
        text001: "signup.verify.verified.text001",
        text002: "signup.verify.verified.text002",
        text003: "signup.verify.verified.text003",
      },
      notVerified: {
        text001: "signup.verify.not-verified.text001",
        text002: "signup.verify.not-verified.text002",
        text003: "signup.verify.not-verified.text003",
      },
      empty: {
        text001: "signup.verify.empty.text001",
        text002: "signup.verify.empty.text002",
        text003: "signup.verify.empty.text003",
      },
    },
  },

  resetpw: {
    text001: "resetpw.text001",
    text002: "resetpw.text002",
    text003: "resetpw.text003",
    text004: "resetpw.text004",
    text005: "resetpw.text005",
    text006: "resetpw.text006",
    text007: "resetpw.text007",
    text008: "resetpw.text008",
    text009: "resetpw.text009",
    text010: "resetpw.text010",
  },

  sideBar: {
    Home: "sideBar.Home",
    Management: "sideBar.Management",
    ClubInformation: "sideBar.Club information",
    CourseInfo: "sideBar.Course info",
    TeeTime: "sideBar.Tee time",
    Pricing: "sideBar.Pricing",
    Charges: "sideBar.Charges",
    PriceSchedule: "sideBar.Price Schedule",
    RoleSettings: "sideBar.Role settings",
    Staff: "sideBar.Staff",
    Reservation: "sideBar.Reservation",
    Customer: "sideBar.Customer",
    MembershipTiers: "sideBar.Membership tiers",
    CustomerList: "sideBar.Customer list",
    ClientList: "sideBar.Client list",
    LogOut: "sideBar.Log out",
    Permissions: "sideBar.Permissions",
    StaffList: "sideBar.Staff list",
    Insights: "sideBar.Insights",
    Calendar: "sideBar.Calendar",
    OpenSchedule: "sideBar.Open Schedule",
    TeeTimeTable: "sideBar.Tee time table",
    ReservationList: "sideBar.Reservation list",
  },

  profile: {
    text001: "profile.text001",
    text002: "profile.text002",
    text003: "profile.text003",
    text004: "profile.text004",
    text005: "profile.text005",
    text006: "profile.text006",
    text007: "profile.text007",
    text008: "profile.text008",
    text009: "profile.text009",
    text010: "profile.text010",
    text011: "profile.text011",
    text012: "profile.text012",
    text013: "profile.text013",
    text014: "profile.text014",
  },

  settingRole: {
    text001: "setting-role.text001",
    text002: "setting-role.text002",
    text003: "setting-role.text003",
    text004: "setting-role.text004",
    text005: "setting-role.text005",
    AdminBit: "setting-role.AdminBit",
    Schedule: "setting-role.Schedule",
    Staff: "setting-role.Staff",
    RoleSetting: "setting-role.Role Setting",
    Reservation: "setting-role.Reservation",
    ClubInformation: "setting-role.Club Information",
    Member: "setting-role.Member",
    Account: "setting-role.Account",
    Dashboard: "setting-role.Dashboard",
  },

  addRole: {
    text001: "add-role.text001",
    text002: "add-role.text002",
    text003: "add-role.text003",
    text004: "add-role.text004",
    text005: "add-role.text005",
    text006: "add-role.text006",
    text007: "add-role.text007",
    text008: "add-role.text008",
    text009: "add-role.text009",
    text010: "add-role.text010",
    text011: "add-role.text011",
    text012: "add-role.text012",
    text013: "add-role.text013",
    text014: "add-role.text014",
    text015: "add-role.text015",
    AdminBit: "add-role.AdminBit",
    Schedule: "add-role.Schedule",
    Staff: "add-role.Staff",
    RoleSetting: "add-role.Role Setting",
    Reservation: "add-role.Reservation",
    ClubInformation: "add-role.Club Information",
    Member: "add-role.Member",
    Account: "add-role.Account",
    Dashboard: "add-role.Dashboard",
  },

  editRole: {
    text001: "edit-role.text001",
    text002: "edit-role.text002",
    text003: "edit-role.text003",
    text004: "edit-role.text004",
    text005: "edit-role.text005",
    text006: "edit-role.text006",
    text007: "edit-role.text007",
    text008: "edit-role.text008",
    text009: "edit-role.text009",
    text010: "edit-role.text010",
    text011: "edit-role.text011",
    text012: "edit-role.text012",
    text013: "edit-role.text013",
    text014: "edit-role.text014",
    text015: "edit-role.text015",
    text016: "edit-role.text016",
    text017: "edit-role.text017",
    text018: "edit-role.text018",
    text019: "edit-role.text019",
    text020: "edit-role.text020",
    text021: "edit-role.text021",
    AdminBit: "edit-role.AdminBit",
    Schedule: "edit-role.Schedule",
    Staff: "edit-role.Staff",
    RoleSetting: "edit-role.Role Setting",
    Reservation: "edit-role.Reservation",
    ClubInformation: "edit-role.Club Information",
    Member: "edit-role.Member",
    Account: "edit-role.Account",
    Dashboard: "edit-role.Dashboard",
    permissionLabel: {
      read: "edit-role.permissionLabel.read",
      create: "edit-role.permissionLabel.create",
      update: "edit-role.permissionLabel.update",
      delete: "edit-role.permissionLabel.delete",
    },
  },

  staff: {
    text001: "staff.text001",
    text002: "staff.text002",
    text003: "staff.text003",
    text004: "staff.text004",
    text005: "staff.text005",
    text006: "staff.text006",
    text007: "staff.text007",
    text008: "staff.text008",
    text009: "staff.text009",
    text010: "staff.text010",
    text011: "staff.text011",
    text012: "staff.text012",
    text013: "staff.text013",
    text014: "staff.text014",
    text015: "staff.text015",
    text016: "staff.text016",
    text017: "staff.text017",
  },

  addStaff: {
    text001: "add-staff.text001",
    text002: "add-staff.text002",
    text003: "add-staff.text003",
    text004: "add-staff.text004",
    text005: "add-staff.text005",
    text006: "add-staff.text006",
    text007: "add-staff.text007",
    text008: "add-staff.text008",
    text009: "add-staff.text009",
    text010: "add-staff.text010",
    text011: "add-staff.text011",
    text012: "add-staff.text012",
    text013: "add-staff.text013",
    text014: "add-staff.text014",
    text015: "add-staff.text015",
    text016: "add-staff.text016",
    text017: "add-staff.text017",
    text018: "add-staff.text018",
  },

  editStaff: {
    text001: "edit-staff.text001",
    text002: "edit-staff.text002",
    text003: "edit-staff.text003",
    text004: "edit-staff.text004",
    text005: "edit-staff.text005",
    text006: "edit-staff.text006",
    text007: "edit-staff.text007",
    text008: "edit-staff.text008",
    text009: "edit-staff.text009",
    text010: "edit-staff.text010",
    text011: "edit-staff.text011",
    text012: "edit-staff.text012",
    text013: "edit-staff.text013",
    text014: "edit-staff.text014",
  },

  reservationTable: {
    text001: "reservation-table.text001",
    text002: "reservation-table.text002",
  },

  reservation: {
    text001: "reservation.text001",
    text002: "reservation.text002",
    text003: "reservation.text003",
    text004: "reservation.text004",
    text005: "reservation.text005",
    text006: "reservation.text006",
    text007: "reservation.text007",
    text008: "reservation.text008",
    text009: "reservation.text009",
    text010: "reservation.text010",
    text011: "reservation.text011",
    text012: "reservation.text012",
    text013: "reservation.text013",
    text014: "reservation.text014",
    text015: "reservation.text015",
    text016: "reservation.text016",
    text017: "reservation.text017",
    text018: "reservation.text018",
    text019: "reservation.text019",
    text020: "reservation.text020",
    text021: "reservation.text021",
    text022: "reservation.text022",
    text023: "reservation.text023",
    text024: "reservation.text024",
    text025: "reservation.text025",
    text026: "reservation.text026",
    text027: "reservation.text027",
    text028: "reservation.text028",
    text029: "reservation.text029",
    text030: "reservation.text030",
    text031: "reservation.text031",
    text032: "reservation.text032",
    text033: "reservation.text033",
    text034: "reservation.text034",
    text035: "reservation.text035",
    pending: "reservation.pending",
    reserved: "reservation.reserved",
    cancelled: "reservation.cancelled",
    noshow: "reservation.noshow",
    deleted: "reservation.deleted",
    table: {
      changeType: {
        CREATE: "reservation.table.changeType.CREATE",
        TIME_CHANGE: "reservation.table.changeType.TIME_CHANGE",
        COURSE_CHANGE: "reservation.table.changeType.COURSE_CHANGE",
        PLAYER_INFO: "reservation.table.changeType.PLAYER_INFO",
        PLAYER_COUNT: "reservation.table.changeType.PLAYER_COUNT",
        PRICE_METHOD: "reservation.table.changeType.PRICE_METHOD",
        STATUS_CHANGE: "reservation.table.changeType.STATUS_CHANGE",
        MEMO_CHANGE: "reservation.table.changeType.MEMO_CHANGE",
        STAFF_ASSIGN: "reservation.table.changeType.STAFF_ASSIGN",
        AUTO_CHANGE: "reservation.table.changeType.AUTO_CHANGE",
        CHANGE_PASSPORT: "reservation.table.changeType.CHANGE_PASSPORT",
        ETC: "reservation.table.changeType.ETC",
      },
      changeField: {
        reservationEmail: "reservation.table.changeField.reservationEmail",
        reservationName: "reservation.table.changeField.reservationName",
        reservationPhoneCode:
          "reservation.table.changeField.reservationPhoneCode",
        reservationPhoneNumber:
          "reservation.table.changeField.reservationPhoneNumber",
        reservationDate: "reservation.table.changeField.reservationDate",
        reservationTime: "reservation.table.changeField.reservationTime",
        courseName: "reservation.table.changeField.courseName",
        playerNum: "reservation.table.changeField.playerNum",
        paymentMethod: "reservation.table.changeField.paymentMethod",
        reservationStatus: "reservation.table.changeField.reservationStatus",
        reservationMemo: "reservation.table.changeField.reservationMemo",
        reservationRequest: "reservation.table.changeField.reservationRequest",
        playerSlot: "reservation.table.changeField.playerSlot",
        playerName: "reservation.table.changeField.playerName",
        playerEmail: "reservation.table.changeField.playerEmail",
        playerPhoneCode: "reservation.table.changeField.playerPhoneCode",
        playerPhoneNumber: "reservation.table.changeField.playerPhoneNumber",
        playerStatus: "reservation.table.changeField.playerStatus",
        lockerNo: "reservation.table.changeField.lockerNo",
        caddieNo: "reservation.table.changeField.caddieNo",
        cartNo: "reservation.table.changeField.cartNo",
        bagNo: "reservation.table.changeField.bagNo",
      },
    },
  },

  offlineReservation: {
    text001: "offline-reservation.text001",
    text002: "offline-reservation.text002",
    text003: "offline-reservation.text003",
    text004: "offline-reservation.text004",
    text005: "offline-reservation.text005",
  },

  reservationDetail: {
    text001: "reservation-detail.text001",
    text002: "reservation-detail.text002",
    text003: "reservation-detail.text003",
    text004: "reservation-detail.text004",
    text005: "reservation-detail.text005",
    text006: "reservation-detail.text006",
    text007: "reservation-detail.text007",
    text008: "reservation-detail.text008",
    text009: "reservation-detail.text009",
    text010: "reservation-detail.text010",
    text011: "reservation-detail.text011",
    text012: "reservation-detail.text012",
    text013: "reservation-detail.text013",
    text014: "reservation-detail.text014",
    text015: "reservation-detail.text015",
    text016: "reservation-detail.text016",
    text017: "reservation-detail.text017",
    text018: "reservation-detail.text018",
    text019: "reservation-detail.text019",
    text020: "reservation-detail.text020",
    text021: "reservation-detail.text021",
    text022: "reservation-detail.text022",
  },

  sales: {
    analytics: {
      current: "sales.analytics.current",
      revenueMonth: "sales.analytics.revenueMonth",
      transactions: "sales.analytics.transactions",
      averageAmount: "sales.analytics.averageAmount",
      reservationRate: "sales.analytics.reservationRate",
      revenueShare: "sales.analytics.revenueShare",
      onOffRate: "sales.analytics.onOffRate",
      paymentMethod: "sales.analytics.paymentMethod",
      byWeekday: "sales.analytics.byWeekday",
      byDate: "sales.analytics.byDate",
    },
    table: {
      date: "sales.table.date",
      paymentId: "sales.table.paymentId",
      category: "sales.table.category",
      item: "sales.table.item",
      qty: "sales.table.qty",
      totalAmount: "sales.table.totalAmount",
      amountPaid: "sales.table.amountPaid",
      discountType: "sales.table.discountType",
      method: "sales.table.method",
      status: "sales.table.status",
      channel: "sales.table.channel",
    },
    filter: {
      category: "sales.filter.category",
      channel: "sales.filter.channel",
      method: "sales.filter.method",
      discount: "sales.filter.discount",
    },
  },

  client: {
    text001: "client.text001",
    text002: "client.text002",
    text003: "client.text003",
    text004: "client.text004",
    text005: "client.text005",
    text006: "client.text006",
    text007: "client.text007",
    text008: "client.text008",
    text009: "client.text009",
    text010: "client.text010",
    text011: "client.text011",
    text012: "client.text012",
    text013: "client.text013",
    text014: "client.text014",
    text015: "client.text015",
    text016: "client.text016",
    all: "client.all",
    pending: "client.pending",
    active: "client.active",
    deleted: "client.deleted",
    suspended: "client.suspended",
  },

  clientProfile: {
    text001: "client-profile.text001",
    text002: "client-profile.text002",
    text003: "client-profile.text003",
    text004: "client-profile.text004",
    text005: "client-profile.text005",
    text006: "client-profile.text006",
    text007: "client-profile.text007",
    text008: "client-profile.text008",
    text009: "client-profile.text009",
    text010: "client-profile.text010",
    text011: "client-profile.text011",
    text012: "client-profile.text012",
    text013: "client-profile.text013",
    text014: "client-profile.text014",
    text015: "client-profile.text015",
    text016: "client-profile.text016",
    text017: "client-profile.text017",
    text018: "client-profile.text018",
    text019: "client-profile.text019",
    text020: "client-profile.text020",
    text021: "client-profile.text021",
    text022: "client-profile.text022",
    text023: "client-profile.text023",
    all: "client-profile.all",
    pending: "client-profile.pending",
    active: "client-profile.active",
    deleted: "client-profile.deleted",
    suspended: "client-profile.suspended",
  },

  membershipTiers: {
    text001: "membership-tiers.text001",
    text002: "membership-tiers.text002",
    text003: "membership-tiers.text003",
    text004: "membership-tiers.text004",
    text005: "membership-tiers.text005",
    text006: "membership-tiers.text006",
    text007: "membership-tiers.text007",
    text008: "membership-tiers.text008",
    text009: "membership-tiers.text009",
    text010: "membership-tiers.text010",
    text011: "membership-tiers.text011",
    text012: "membership-tiers.text012",
    text013: "membership-tiers.text013",
    text014: "membership-tiers.text014",
    text015: "membership-tiers.text015",
    text016: "membership-tiers.text016",
  },

  membershipEdit: {
    text001: "membership-edit.text001",
    text002: "membership-edit.text002",
    text003: "membership-edit.text003",
    text004: "membership-edit.text004",
    text005: "membership-edit.text005",
    text006: "membership-edit.text006",
    text007: "membership-edit.text007",
    text008: "membership-edit.text008",
    text009: "membership-edit.text009",
    text010: "membership-edit.text010",
    text011: "membership-edit.text011",
    text012: "membership-edit.text012",
    text013: "membership-edit.text013",
    text014: "membership-edit.text014",
    text015: "membership-edit.text015",
    text016: "membership-edit.text016",
    text017: "membership-edit.text017",
    text018: "membership-edit.text018",
    text019: "membership-edit.text019",
    text020: "membership-edit.text020",
    text021: "membership-edit.text021",
    text022: "membership-edit.text022",
    text023: "membership-edit.text023",
    text024: "membership-edit.text024",
    text025: "membership-edit.text025",
    text026: "membership-edit.text026",
    text027: "membership-edit.text027",
    text028: "membership-edit.text028",
    text029: "membership-edit.text029",
    text030: "membership-edit.text030",
    text031: "membership-edit.text031",
    text032: "membership-edit.text032",
    text033: "membership-edit.text033",
    text034: "membership-edit.text034",
    text035: "membership-edit.text035",
    text036: "membership-edit.text036",
    text037: "membership-edit.text037",
  },

  customerList: {
    text001: "customer-list.text001",
    text002: "customer-list.text002",
    text003: "customer-list.text003",
    text004: "customer-list.text004",
    text005: "customer-list.text005",
    text006: "customer-list.text006",
    text007: "customer-list.text007",
    text008: "customer-list.text008",
    text009: "customer-list.text009",
    text010: "customer-list.text010",
    text011: "customer-list.text011",
    text012: "customer-list.text012",
    text013: "customer-list.text013",
    text014: "customer-list.text014",
    text015: "customer-list.text015",
    text016: "customer-list.text016",
    text017: "customer-list.text017",
  },

  customerEdit: {
    text001: "customer-edit.text001",
    text002: "customer-edit.text002",
    text003: "customer-edit.text003",
    text004: "customer-edit.text004",
    text005: "customer-edit.text005",
    text006: "customer-edit.text006",
    text007: "customer-edit.text007",
    text008: "customer-edit.text008",
    text009: "customer-edit.text009",
    text010: "customer-edit.text010",
    text011: "customer-edit.text011",
    text012: "customer-edit.text012",
    text013: "customer-edit.text013",
    text014: "customer-edit.text014",
    text015: "customer-edit.text015",
    text016: "customer-edit.text016",
    text017: "customer-edit.text017",
    text018: "customer-edit.text018",
    text019: "customer-edit.text019",
    text020: "customer-edit.text020",
    text021: "customer-edit.text021",
    text022: "customer-edit.text022",
    text023: "customer-edit.text023",
    text024: "customer-edit.text024",
    text025: "customer-edit.text025",
    text026: "customer-edit.text026",
    text027: "customer-edit.text027",
    text028: "customer-edit.text028",
    text029: "customer-edit.text029",
    text030: "customer-edit.text030",
    text031: "customer-edit.text031",
    text032: "customer-edit.text032",
    text033: "customer-edit.text033",
    text034: "customer-edit.text034",
    text035: "customer-edit.text035",
    text036: "customer-edit.text036",
    text037: "customer-edit.text037",
    text038: "customer-edit.text038",
    text039: "customer-edit.text039",
    text040: "customer-edit.text040",
    text041: "customer-edit.text041",
    text042: "customer-edit.text042",
    text043: "customer-edit.text043",
    text044: "customer-edit.text044",
    text045: "customer-edit.text045",
    text046: "customer-edit.text046",
    text047: "customer-edit.text047",
    text048: "customer-edit.text048",
    text049: "customer-edit.text049",
    text050: "customer-edit.text050",
    text051: "customer-edit.text051",
    text052: "customer-edit.text052",
  },

  response: {
    message01: "response.message01",
  },

  priceSchedule: {
    text001: "price-schedule.text001",
    text002: "price-schedule.text002",
    text003: "price-schedule.text003",
    text004: "price-schedule.text004",
    text005: "price-schedule.text005",
    text006: "price-schedule.text006",
    text007: "price-schedule.text007",
    text016: "price-schedule.text016",
    text017: "price-schedule.text017",
  },

  insights: {
    text001: "insights.text001",
  },

  addSchedule: {
    text001: "add-schedule.text001",
    text002: "add-schedule.text002",
    text003: "add-schedule.text003",
    text004: "add-schedule.text004",
    text005: "add-schedule.text005",
    text006: "add-schedule.text006",
    text007: "add-schedule.text007",
    text008: "add-schedule.text008",
    text009: "add-schedule.text009",
  },

  addGolfClub: {
    text001: "add-golf-club.text001",
    text002: "add-golf-club.text002",
    text003: "add-golf-club.text003",
    text004: "add-golf-club.text004",
    text005: "add-golf-club.text005",
    text006: "add-golf-club.text006",
    text007: "add-golf-club.text007",
    text008: "add-golf-club.text008",
    text009: "add-golf-club.text009",
    text010: "add-golf-club.text010",
    text011: "add-golf-club.text011",
    text012: "add-golf-club.text012",
    text013: "add-golf-club.text013",
    text014: "add-golf-club.text014",
    text015: "add-golf-club.text015",
    text016: "add-golf-club.text016",
    text017: "add-golf-club.text017",
    text018: "add-golf-club.text018",
    text019: "add-golf-club.text019",
    text020: "add-golf-club.text020",
    text021: "add-golf-club.text021",
    text022: "add-golf-club.text022",
    text023: "add-golf-club.text023",
    text024: "add-golf-club.text024",
    text025: "add-golf-club.text025",
    text026: "add-golf-club.text026",
    text027: "add-golf-club.text027",
    text028: "add-golf-club.text028",
    text029: "add-golf-club.text029",
    text030: "add-golf-club.text030",
    text031: "add-golf-club.text031",
    text032: "add-golf-club.text032",
    text033: "add-golf-club.text033",
    text034: "add-golf-club.text034",
    text035: "add-golf-club.text035",
    text036: "add-golf-club.text036",
  },

  priceUpdate: {
    text098: "price-update.text098",
    text099: "price-update.text099",
  },

  component: {
    input: {
      options: {
        manual: "component.input.options.manual",
      },
      file: {
        maxSize: "component.input.file.maxSize",
      },
    },
    tableFilter: {
      search: "component.tableFilter.search",
      reset: "component.tableFilter.reset",
      date: "component.tableFilter.date",
    },
  },

  draft: {
    askRestore: "draft.askRestore",
    restore: "draft.restore",
  },

  notification: {
    waitAssign: "notification.waitAssign",
  },

  error: {
    fileRead: "error.fileRead",
  },

  common: {
    days: {
      sun: "common.days.sun",
      mon: "common.days.mon",
      tue: "common.days.tue",
      wed: "common.days.wed",
      thu: "common.days.thu",
      fri: "common.days.fri",
      sat: "common.days.sat",
    },
    today: "common.today",

    confirm: "common.confirm",
    cancel: "common.cancel",
    yes: "common.yes",
    no: "common.no",
    save: "common.save",
    delete: "common.delete",
    name: "common.name",
    reset: "common.reset",
    active: "common.active",
    disabled: "common.disabled",
    public: "common.public",
    membership: "common.membership",
    image: "common.image",
    open: "common.open",
    close: "common.close",
    refund: "common.refund",
    duplicate: "common.duplicate",
    appPermission: "common.appPermission",
    none: "common.none",
    manager: "common.manager",
    caddie: "common.caddie",
    fnb: "common.fnb",
    message: {
      askDelete: "common.message.askDelete",
      delete: "common.message.delete",
      create: "common.message.create",
      askDuplicate: "common.message.askDuplicate",
      duplicate: "common.message.duplicate",
    },
  },
};
